var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from 'react';
import DropDown from './inputs/DropDown';
import DocumentUploadButton from './DocumentUploadButton';
import LabelWrapper from './LabelWrapper';
var DocumentUpload = function (_a) {
    var _b, _c, _d, _e;
    var dropDownProps = _a.dropDownProps, label = _a.label, disabled = _a.disabled, required = _a.required, renderDropDown = _a.renderDropDown, uploadButtonProps = _a.uploadButtonProps, _f = _a.dropdownButtonContainerClassNames, dropdownButtonContainerClassNames = _f === void 0 ? '' : _f, onDocUpload = _a.onDocUpload;
    var _g = __read(useState((_b = dropDownProps.defaultValue) !== null && _b !== void 0 ? _b : null), 2), currentDocumentKey = _g[0], setCurrentDocumentKey = _g[1];
    var _h = __read(useState(dropDownProps.options), 2), documentOptionsLocal = _h[0], setDocumentOptionsLocal = _h[1];
    useEffect(function () {
        setDocumentOptionsLocal(dropDownProps.options);
    }, [dropDownProps.options]);
    var customSort = function (a, b, rawInput) {
        var inputValue = rawInput.trim().toLowerCase();
        var labelA = a.label.toLowerCase();
        var labelB = b.label.toLowerCase();
        if (labelA.startsWith(inputValue) && labelB.startsWith(inputValue)) {
            return labelA.localeCompare(labelB);
        }
        if (labelA.startsWith(inputValue)) {
            return -1;
        }
        if (labelB.startsWith(inputValue)) {
            return 1;
        }
        return labelA.localeCompare(labelB);
    };
    var onInputChange = function (value, meta) {
        var _a;
        if (meta === 'input') {
            var sortedOptions = (_a = __spreadArray([], __read(dropDownProps.options), false)) === null || _a === void 0 ? void 0 : _a.sort(function (a, b) { return customSort(a, b, value); });
            setDocumentOptionsLocal(sortedOptions);
        }
    };
    var handleFileUpload = function (file) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            onDocUpload === null || onDocUpload === void 0 ? void 0 : onDocUpload(file, currentDocumentKey);
            return [2 /*return*/];
        });
    }); };
    return (React.createElement(LabelWrapper, { label: label, disabled: disabled, required: required },
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: " ".concat(dropdownButtonContainerClassNames !== null && dropdownButtonContainerClassNames !== void 0 ? dropdownButtonContainerClassNames : 'lfc-flex lfc-items-center') },
                renderDropDown && (React.createElement(DropDown, __assign({}, dropDownProps, { onChange: function (_ev, value) {
                        var _a;
                        var rest = [];
                        for (var _i = 2; _i < arguments.length; _i++) {
                            rest[_i - 2] = arguments[_i];
                        }
                        setCurrentDocumentKey(value);
                        (_a = dropDownProps === null || dropDownProps === void 0 ? void 0 : dropDownProps.onChange) === null || _a === void 0 ? void 0 : _a.call.apply(_a, __spreadArray([dropDownProps, _ev, value], __read(rest), false));
                    }, disabled: (_c = dropDownProps === null || dropDownProps === void 0 ? void 0 : dropDownProps.disabled) !== null && _c !== void 0 ? _c : disabled, required: (_d = dropDownProps === null || dropDownProps === void 0 ? void 0 : dropDownProps.required) !== null && _d !== void 0 ? _d : required, className: "lfc-w-full lfc-mr-2 ".concat((_e = dropDownProps === null || dropDownProps === void 0 ? void 0 : dropDownProps.className) !== null && _e !== void 0 ? _e : ''), options: documentOptionsLocal, onInputChange: function (event, value, reason) {
                        onInputChange(value, reason);
                    } }))),
                React.createElement(DocumentUploadButton, __assign({}, uploadButtonProps, { onUpload: handleFileUpload, buttonProps: __assign(__assign({}, uploadButtonProps === null || uploadButtonProps === void 0 ? void 0 : uploadButtonProps.buttonProps), { disabled: renderDropDown && !currentDocumentKey }) }))))));
};
export default DocumentUpload;
//# sourceMappingURL=DocumentUpload.js.map